export type DiagramKind = "graphviz" | "abc" | "echarts";

export function diagramKindFromLanguage(lang: string | undefined): DiagramKind | null {
  switch ((lang ?? "").toLowerCase()) {
    case "graphviz":
    case "dot":
      return "graphviz";
    case "abc":
      return "abc";
    case "echarts":
      return "echarts";
    default:
      return null;
  }
}

async function renderGraphviz(el: HTMLElement, source: string): Promise<void> {
  const { instance } = await import("@viz-js/viz");
  const viz = await instance();
  const svg = viz.renderSVGElement(source);
  svg.style.maxWidth = "100%";
  svg.style.height = "auto";
  el.replaceChildren(svg);
}

async function renderAbc(el: HTMLElement, source: string): Promise<void> {
  const { renderAbc } = await import("abcjs");
  el.replaceChildren();
  renderAbc(el, source, { responsive: "resize" });
}

async function renderECharts(el: HTMLElement, source: string): Promise<void> {
  const echarts = await import("echarts");
  const option = JSON.parse(source) as Record<string, unknown>;

  const existing = echarts.getInstanceByDom(el);
  const chart = existing ?? echarts.init(el, undefined, { renderer: "svg" });
  chart.setOption(option, true);
}

export async function renderDiagram(
  kind: DiagramKind,
  source: string,
  el: HTMLElement,
): Promise<void> {
  if (kind === "graphviz") return renderGraphviz(el, source);
  if (kind === "abc") return renderAbc(el, source);
  return renderECharts(el, source);
}

export async function renderDiagramToString(
  kind: DiagramKind,
  source: string,
): Promise<string> {
  if (kind === "graphviz") {
    const { instance } = await import("@viz-js/viz");
    const viz = await instance();
    return viz.renderString(source, { format: "svg" });
  }
  if (kind === "abc") {
    const { renderAbc } = await import("abcjs");
    const tmp = document.createElement("div");
    renderAbc(tmp, source, { responsive: "resize" });
    return tmp.innerHTML;
  }
  const echarts = await import("echarts");
  const option = JSON.parse(source) as Record<string, unknown>;

  const chart = echarts.init(null, undefined, {
    renderer: "svg",
    ssr: true,
    width: 600,
    height: 360,
  });
  chart.setOption(option);
  const svg = chart.renderToSVGString();
  chart.dispose();
  return svg;
}
